/*
    ---------------------
    - Table of Contents -
    1.0 - Abstracts
    2.0 - Base
    3.0 - Components
    ---------------------
*/

/* 1.0 - Abstracts */
@import '../../../scss/abstracts/variables';

/* 2.0 - Base */
@import '../../../scss/base/reset';
@import '../../../scss/base/fonts';
@import '../../../scss/base/helpers';

@import '~flatpickr/dist/flatpickr.css';
@import '~intl-tel-input/build/css/intlTelInput.min.css';

/* 3.0 - Components */
@import '../../../scss/components/buttons';
@import '../../../scss/components/displaying';
@import '../../../scss/components/texts';
@import '../../../scss/components/forms';
@import '../../../scss/components/animations';
@import '../../../scss/components/tiles';
@import '../../../scss/components/toggles';
@import '../../../scss/components/structures';
@import '../../../scss/components/breadcrumb';
@import '../../../scss/base/breakpoints';

@import '../../../scss/lib/flatpickr';

ike-layout {
  flex-grow: 1;
}

.layout{
  --white: #{$white};
  --black: #{$black};

  --main-color: #{$main-color};
  --main-color-text: #{$main-color-text};

  --blue: #{$blue};
  --orange: #{$orange};
  --green: #{$green};
  --red: #{$red};

  --gray-whitish: #{$gray-whitish};
  --gray-extra-light: #{$gray-extra-light};
  --gray-medium: #{$gray-medium};
  --gray-dark: #{$gray-dark};
  --blue-hover-1: #{$blue-hover-1};
  --blue-hover-1-darker: #{$blue-hover-1-darker};

  @mixin dark-theme {
    --white: #181a1b;
    --black: #fff;

    --gray-extra-light: #2a2d2f;
    --gray-whitish: #2a2d2f;
    --gray-medium: #c8c3bc;
    --gray-dark: #ffffff;

    --blue-hover-1:#3E435B;
    --blue-hover-darker:#252837;
  }

  &.dark{
    @include dark-theme;
  }

  &:not(.light){
    @media (prefers-color-scheme: dark) {
      @include dark-theme;
    }
  }

  background-color: $gray-whitish;
  background-color: var(--gray-whitish);

  &.EMBEDED {
    background-color: transparent !important;
  }

  &:not(.EMBEDED){
    display: flex;
    flex-direction: column;
    padding-bottom: 64px;
  }

  &.PROFILE {
    height: unset;
    flex-grow: 1;
  }

  &.showPeriodList {
    background-color: $gray-whitish;
    background-color: var(--gray-whitish);
  }

}

.loadingBar {
  animation-fill-mode: forwards;
  animation: progress-bar-mid 1s cubic-bezier(.17,.67,.83,.67);
  background: $main-color;
  background: var(--main-color);
  height: 2px;
  left: 0;
  margin: 0;
  pointer-events: none;
  top: 0;
  width: 0;
  position: absolute;
  z-index: 20000;

  &__full {
    animation: progress-bar-last 1s cubic-bezier(.17,.67,.83,.67) !important;
  }
}

.show-notif {
  bottom:0 !important;
}

.loading {
  height: 0 !important;
  margin: unset !important;
  opacity: 0;
  display: block;
}

.loader {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 400px;
  justify-content: center;
  margin: 0 auto;
  width: 300px;

  :not(.EMBEDED) > & {
    margin-top: 100px;
    height: 50vh;
  }

  .layout-padding {
    margin-top:90px;
  }

  &__img {
    margin-bottom:30px;
    width: 46px;
  }

  .progress-bar {
    height: 7px;
    width: 200px;

    &__bg {
      background-color: $gray-whitish;
      background-color: var(--gray-whitish);
      border-radius: 3.42px;
      height: 100%;
      width: 100%;
    }

    &__loader {
      animation: progress-bar 1s cubic-bezier(.17,.67,.83,.67);
      background: $main-color;
      background: var(--main-color);
      border-radius: 4px;
      height: 100%;
    }
  }
}

@keyframes progress-bar {
  from { width : 0; }
  to { width : 100%; }
}
@keyframes progress-bar-mid {
  from { width : 0; }
  to { width : 70%; }
}
@keyframes progress-bar-last {
  from { width : 70%; }
  to { width : 100%; }
}

.period-listing {
  max-width: 1320px;
  margin: auto;
  padding: 20px;
  gap: 20px;
  display: flex;
  flex-direction: column;
}

.notifications {
  z-index: 1500 !important;
  align-items: center;
  bottom: -500px;
  bottom: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  left: 0;
  max-width: 100%;
  position: fixed;
  transition: all 500ms cubic-bezier(0.175, 0.885, 0.320, 1.275); /* easeOutBack */
  width: 100%;
  z-index: 1000;

  > div {
    align-items: center;
    background-color: $white;
    background-color: var(--white);
    border-radius: 8px;
    box-shadow: 0 5px 20px 0 rgba(0,0,0,0.15);
    display: inline-flex;
    font-weight: 700;
    font-size: 16px;
    height: fit-content;
    letter-spacing: 0;
    line-height: 21px;
    margin-bottom: 20px;
    padding: 14px 15px;
    padding-right: 0px;
    width: 90%;
    max-width: 600px;
    position: relative;

    .rab_ssergorp {
      width: 100%;
      height: 5px;
      position: absolute;
      bottom: 0px;
      left: 0px;
      background-color: $main-color;
      background-color: var(--main-color);
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 10px;
      border-top-right-radius: 10px;
      -webkit-transition:width 3s linear !important;
      -moz-transition:width 3s linear !important;
      -o-transition:width 3s linear !important;
      -ms-transition:width 3s linear !important;
      transition:width 3s linear !important;
      z-index:20;
    }

    .rab_ssergorp_bg {
      width: 100%;
      height: 5px;
      position: absolute;
      bottom: 0px;
      left: 0px;
      background-color: $main-color;
      background-color: var(--main-color);
      opacity: 0.5;
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
    }

    .notification-content {
      display: flex;
      .notification-message {
        font-weight: normal;
        padding-top: 10px;
        font-size: 14px;
      }
      div{
        margin-right: 25px;
        word-break: break-word;
      }
    }

    .notification-close {
      cursor: pointer;
      i.icon-close {
        font-weight: bold;
        font-size: 12px;
        color: $gray-dark;
        color: var(--gray-dark);
      }
    }

    i {
      font-size: 20px;
      margin-right:20px;
    }

    &.success i {
      color : #3EBF4D;
    }

    &.warning i {
      color : #FF8500;
    }

    &.error {
      color: $gray-dark;
      color: var(--gray-dark);
      i {
        color : #FB472E;
      }

    }
  }
}

.error {
  color: #FB472E;
}
